import { createStore } from "vuex";
import { User } from "@/models/users/user";
import survey from "./survey";
import nickname from "./nickname";
import notification from "./notification";

const moduleUser = {
  state() {
    return {
      user: null,
    };
  },
  getters: {
    getUser(state: any) {
      return state.user;
    },
  },
  mutations: {
    setUser(state: any, payload: any) {
      state.user = payload;
    },
  },
  actions: {
    async fetchUser({ commit }: any) {
      // ユーザー情報取得
      // TODO: 現状、ユーザーAPIはダミーの情報を返している、要実装
      const user = new User();
      return await user.fetch().then(([model, response, error]) => {
        if (error) {
          console.log("fetch error: user data");
          return;
        }
        commit("setUser", model.attributes);
        console.log("fetch success: user data");
      });
    },
    setUser({ commit }: any, payload: any) {
      commit("setUser", payload);
    },
  },
};

export default createStore({
  modules: {
    user: moduleUser,
    survey: survey,
    nickname: nickname,
    notification: notification,
  },
});
